<style scoped>
  .container {
    min-height: 100vh
  }
</style>

<template lang="pug">
  .container
    .vspace.large
    .row
      p.title.large.col.s12 Reset Password
    .preloader-wrapper.small.active.input-icon-right(v-if='!isTokenChecked')
      .spinner-layer.spinner-green-only
        .circle-clipper.left
          .circle
        .gap-patch
          .circle
        .circle-clipper.right
          .circle
    div(v-else)
      form.row(@submit.prevent='submit' novalidate v-if='isTokenValid && !passwordResetSuccessful')
        .input-field.col.s12
          input#password(
            name='password'
            type='password'
            v-validate='validations.password'
            v-model='password')
          label(for='password') New Password
          span.helper-text.red-text(v-if='fields.password && fields.password.touched') {{errors.first('password')}}
        .input-field.col.s12
          input#repassword(
            name='repassword'
            type='password'
            v-validate='validations.repassword'
            v-model='repassword')
          label(for='repassword') Repeat Password
          span.helper-text.red-text(v-if='fields.repassword && fields.repassword.touched') {{errors.first('repassword')}}
        .col.s12.right-align
          button.btn(type='submit') Submit
      .row(v-else-if='passwordResetSuccessful') 
        p.green-text.col.s12
          i.material-icons.left check_circle
          span Password Reset Successful
      .row(v-else)
        p.col.s12.red-text
          i.material-icons.left cancel
          span Invalid password reset request
</template>
<script>
export default {
  data () {
    return {
      password: null,
      repassword: null,
      isTokenValid: false,
      isTokenChecked: false,
      passwordResetSuccessful: false,
      errorMessages: {
        custom: {
          repassword: {
            required: () => 'Password must be repeated',
            is: () => 'Passwords do not match'
          }
        }
      }
    }
  },
  computed: {
    validations () {
      return {
        password: {
          required: true,
          max: 255
        },
        repassword: {
          required: true,
          is: this.password
        }
      }
    }
  },
  created () {
    this.$validator.localize('en', this.errorMessages)
    this.validateToken(this.$route.query.t)
  },
  methods: {
    validateToken (token) {
      if (!token) {
        this.isTokenChecked = true
        this.isTokenValid = false
      }

      this.$http.get(`${this.$config.API_URL}/account/request-password-reset/validate`, {
        params: {
          t: token
        }
      }).then(result => {
        this.isTokenChecked = true
        this.isTokenValid = result.data.isValid
      }).catch(err => {
        this.$snackbar.error('An unexpected error: ' + err.message)
      })
    },
    submit () {
      this.$validator.validate().then(isValid => {
        if (!isValid) {
          return
        }

        this.$http.post(`${this.$config.API_URL}/account/reset-password`, {
          token: this.$route.query.t,
          newPassword: this.password
        }).then(() => {
          this.passwordResetSuccessful = true
        }).catch(err => {
          this.$snackbar.error('An unexpected error: ' + err.message)
        })
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/page-reset-password.vue